/**
 * TEXTO LEGAL ÚNICO del consentimiento previo a responder un cuestionario clínico.
 *
 * ⚖️ TEXTO LEGAL — redactado y aprobado por Ann (21-jul-2026).
 * NO reescribir, resumir ni "mejorar" su redacción: es información obligatoria
 * de protección de datos (RGPD art. 13 + LOPDGDD). Cualquier cambio debe venir
 * pedido por escrito por Ann.
 *
 * Vive aquí y NO duplicado en cada pantalla para que los tres sitios donde se
 * pide el consentimiento muestren EXACTAMENTE lo mismo:
 *   · frontend/src/pages/TabletCuestionario.jsx            (tablet / QR en clínica)
 *   · frontend/src/components/admin/clinica/EvaluacionWizard.jsx  (en consulta)
 *   · frontend/src/components/patient/PatientQuestionnaireWizard.jsx (plataforma del paciente)
 */

export const RESPONSABLE = {
  razon_social: 'CENTRO PILAR DOMÍNGUEZ S.L.',
  nif: 'B62825856',
  direccion: 'C/ Muntaner 239, ent. 1, Barcelona',
  email: 'clientes@metodopilardominguez.com',
  telefono: '934142860',
  dpd: 'SIB Group (empresa externa)',
};

export const CONSENTIMIENTO_TITULO = 'INFORMACIÓN SOBRE PROTECCIÓN DE DATOS';

export const CONSENTIMIENTO_INTRO =
  'De conformidad con el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD), le informamos:';

/** Apartados del texto legal, en orden. */
export const CONSENTIMIENTO_APARTADOS = [
  {
    titulo: 'Responsable del tratamiento',
    texto: `${RESPONSABLE.razon_social}, NIF ${RESPONSABLE.nif}, con domicilio en ${RESPONSABLE.direccion}. Email: ${RESPONSABLE.email}. Tel.: ${RESPONSABLE.telefono}`,
  },
  {
    titulo: 'Delegado de Protección de Datos',
    texto: RESPONSABLE.dpd,
  },
  {
    titulo: 'Finalidad',
    texto:
      'los datos que facilite en este cuestionario serán tratados con finalidad sanitaria: su evaluación clínica, la elaboración y mantenimiento de su historia clínica y el seguimiento de su tratamiento fisioterapéutico.',
  },
  {
    titulo: 'Base jurídica',
    texto:
      'el tratamiento es necesario para la prestación de asistencia sanitaria y se ampara en el art. 9.2.h) del RGPD y en la Ley 41/2002, de autonomía del paciente, sin que se requiera su consentimiento para esta finalidad asistencial.',
  },
  {
    titulo: 'Conservación',
    texto:
      'los datos se conservarán como parte de su historia clínica durante los plazos legalmente exigidos (mínimo 15 años desde el alta de cada proceso asistencial, conforme a la Ley 21/2000 de Cataluña), y posteriormente serán suprimidos o anonimizados.',
  },
  {
    titulo: 'Destinatarios',
    texto:
      'no se cederán datos a terceros salvo obligación legal o, en su caso, a su entidad aseguradora o mutua cuando sea necesario para la gestión y facturación de la asistencia. No se realizan transferencias internacionales de datos.',
  },
  {
    titulo: 'Confidencialidad',
    texto:
      'sus respuestas serán tratadas de forma estrictamente confidencial, almacenadas con medidas de seguridad adecuadas y accesibles únicamente por el equipo terapéutico que le atiende, sujeto a secreto profesional.',
  },
  {
    titulo: 'Derechos',
    texto: `puede ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad dirigiéndose por escrito al responsable en ${RESPONSABLE.email} o ${RESPONSABLE.direccion}, acompañando copia de su documento de identidad. La supresión no será posible respecto de los datos que deban conservarse legalmente como parte de la historia clínica. Asimismo, puede presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) o la Autoritat Catalana de Protecció de Dades.`,
  },
];

/** Casilla OBLIGATORIA para poder continuar. */
export const CONSENTIMIENTO_OBLIGATORIO =
  'He leído y comprendo la información sobre el tratamiento de mis datos.';

/** Casilla OPCIONAL: no bloquea el cuestionario y se guarda marcada o sin marcar. */
export const CONSENTIMIENTO_OPCIONAL =
  'Consiento que mis respuestas se utilicen, de forma anonimizada, para la evaluación y mejora de los tratamientos ofrecidos por el centro. Puedo retirar este consentimiento en cualquier momento sin que ello afecte a mi asistencia.';

/** Versión del texto: queda guardada con cada respuesta (prueba de QUÉ aceptó el paciente). */
export const CONSENTIMIENTO_VERSION = '2026-07-21';
